// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"blockquote-module--blockquote--3yhBD","mark":"blockquote-module--mark--kOrwR"};